// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"c4a38bff","475":"b91a00c0","497":"554e65ec","548":"0a02f207","692":"e6c8bd73","721":"31f7b1e4","771":"1a916b46","896":"1a916b46"}[chunkId] + ".chunk.css";
};